export const INITIAL_STAGE_HANDLE = 'problemArea';
export const END_STAGE_HANDLES = ['submitClaim'];
